import { createSlice } from "@reduxjs/toolkit";
import {
  BdPerson,
  PDetailsPrice,
} from "../../actions/adminActions/newOrderRequestAction";

const initialState = {
  bd_person: [],
  product_with_price: [],
};

const NewOrderRequestSlice = createSlice({
  name: "bdPersonDetails",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(BdPerson.fulfilled, (state, { payload }) => {
      //   console.log("Fetched BD Persons:", payload);
      state.bd_person = payload?.data?.data;
    });
    builder.addCase(BdPerson.rejected, (state, action) => {
      console.error("Fetch Bd Person failed:", action.error.message);
    });
    // for product details with price
    builder.addCase(PDetailsPrice.fulfilled, (state, { payload }) => {
      // console.log("Product's detail is: ", payload);
      state.product_with_price = payload?.data?.data;
    });
    builder.addCase(PDetailsPrice.rejected, (state, action) => {
      console.error(
        "Fetch product Details with Price failed:",
        action.error.message
      );
    });
  },
});

export default NewOrderRequestSlice.reducer;
